import { render, staticRenderFns } from "./consignacaoDetalhe.vue?vue&type=template&id=39a91907&scoped=true&"
import script from "./consignacaoDetalhe.vue?vue&type=script&lang=js&"
export * from "./consignacaoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./consignacaoDetalhe.vue?vue&type=style&index=0&id=39a91907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a91907",
  null
  
)

export default component.exports